import axios from "axios";

export const geraTokenGetnet = async (clientName) => {
  try {
    const headerGeraTokenGentet = {
      headers: {
        clientName: clientName,
      },
    };

    const geraToken = await axios.post(
      process.env.REACT_APP_APIGETNET_URL + "gerarTokenAcesso",
      {},
      headerGeraTokenGentet
    );

    return geraToken;
  } catch (error) {
    return {
      msg: `Error na requisição gerarTokenAcesso ${error}`,
      status: "erro",
      dados: [],
    };
  }
};
